module.exports = __webpack_public_path__ + "media/barometer_linkedin/report-cover-7aeb5413.png";